import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { getSelectedScopeId } from './';
import { AuthorizationContext } from './AuthorizationContext';
export const AuthorizationProvider = ({ children }) => {
    const [authorizationScopeId, setAuthorizationScopeId] = useState(undefined);
    const [authorizationScopes, setAuthorizationScopes] = useState(undefined);
    const permissions = useMemo(() => {
        getSelectedScopeId().setValue(authorizationScopeId);
        const scopePermissions = authorizationScopeId && authorizationScopes && authorizationScopeId in authorizationScopes
            ? authorizationScopes[authorizationScopeId]
            : undefined;
        return scopePermissions;
    }, [authorizationScopeId, authorizationScopes]);
    return (_jsx(AuthorizationContext.Provider, { value: { authorizationScopeId, authorizationScopes, permissions, setAuthorizationScopeId, setAuthorizationScopes }, children: children }));
};
